import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Card, Flex } from "antd";
import { useEffect, useState } from "react";
import Cash from "./Cash";
import CreditCard from "./CreditCard";
import EWallet from "./EWallet";

export default function PaymentCard(props) {
  const {
    plates,
    setIsShowPayment,
    onPaymentSuccessReset,
    setIsDisableButton,
    receiptPrice,
    setReceiptPrice,
    itemDetailsCardRef,
    setExtraChargesOptions,
    connectDevice,
    setConnectDevice,
  } = props;

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  const [
    isDisplayChangePaymentMethodButton,
    setIsDisplayChangePaymentMethodButton,
  ] = useState("none");
  const [isDisableCancelPaymentButton, setIsDisableCancelPaymentButton] =
    useState(false);
  const [transactionInfo, setTransactionInfo] = useState();

  const onCancelPaymentButtonClicked = () => {
    setIsDisableButton((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false]))
    );
    resetPaymentPriceMethod(false);
  };

  const onChangePaymentMethodButtonClicked = () => {
    resetPaymentPriceMethod(true);
  };

  const resetPaymentPriceMethod = (showPayment) => {
    setIsShowPayment(showPayment);
    setSelectedPaymentMethod(null);
    setReceiptPrice((prev) => ({
      ...prev,
      total: receiptPrice.subtotal + receiptPrice.sst,
      change: null,
      round_adj: null,
      cash: null,
    }));
  };

  function onPaymentMethodSelected(method) {
    setSelectedPaymentMethod(method);
    setIsDisableButton((prev) => ({ ...prev, pay_btn: true }));
  }

  const PAYMENT_METHOD = {
    Cash: (
      <Cash
        plates={plates}
        onPaymentSuccessReset={onPaymentSuccessReset}
        receiptPrice={receiptPrice}
        setReceiptPrice={setReceiptPrice}
        transactionInfo={transactionInfo}
        setTransactionInfo={setTransactionInfo}
        setExtraChargesOptions={setExtraChargesOptions}
        connectDevice={connectDevice}
        setConnectDevice={setConnectDevice}
      />
    ),
    "E-Wallet": (
      <EWallet
        plates={plates}
        onPaymentSuccessReset={onPaymentSuccessReset}
        receiptPrice={receiptPrice}
        setReceiptPrice={setReceiptPrice}
        transactionInfo={transactionInfo}
        setTransactionInfo={setTransactionInfo}
        setExtraChargesOptions={setExtraChargesOptions}
        connectDevice={connectDevice}
        setConnectDevice={setConnectDevice}
      />
    ),
    "Credit Card": (
      <CreditCard
        plates={plates}
        onPaymentSuccessReset={onPaymentSuccessReset}
        receiptPrice={receiptPrice}
        setReceiptPrice={setReceiptPrice}
        transactionInfo={transactionInfo}
        setTransactionInfo={setTransactionInfo}
        setExtraChargesOptions={setExtraChargesOptions}
        connectDevice={connectDevice}
        setConnectDevice={setConnectDevice}
      />
    ),
  };

  useEffect(() => {
    const valideMethods = ["Cash", "E-Wallet", "Credit Card"];
    setIsDisplayChangePaymentMethodButton(
      valideMethods.includes(selectedPaymentMethod) ? "unset" : "none"
    );
  }, [selectedPaymentMethod]);

  useEffect(() => {
    if (selectedPaymentMethod != null) {
      setIsDisableButton((prev) => ({ ...prev, cancel_order_btn: true }));
    } else {
      setIsDisableButton((prev) => ({ ...prev, cancel_order_btn: false }));
    }
  }, [selectedPaymentMethod]);

  return (
    <div ref={itemDetailsCardRef} style={{ height: "100%", width: "100%" }}>
      <Card
        style={{ height: "100%" }}
        styles={{ body: { height: "calc(100% - 56px)", padding: 10 } }}
        title={
          <Button
            type="primary"
            danger
            icon={<CloseCircleOutlined />}
            onClick={onCancelPaymentButtonClicked}
            disabled={isDisableCancelPaymentButton}
            style={{ fontWeight: "bold" }}
          >
            Cancel Payment
          </Button>
        }
        extra={
          <Button
            type="primary"
            onClick={onChangePaymentMethodButtonClicked}
            style={{
              fontWeight: "bold",
              display: isDisplayChangePaymentMethodButton,
            }}
          >
            Change Payment Method
          </Button>
        }
      >
        <div style={{ height: "100%", width: "100%" }}>
          {selectedPaymentMethod ? (
            PAYMENT_METHOD[selectedPaymentMethod]
          ) : (
            <Flex
              wrap
              style={{ height: "100%", width: "100%" }}
              justify="space-evenly"
              align="center"
            >
              {Object.keys(PAYMENT_METHOD).map((key) => {
                return (
                  <Button
                    key={key}
                    className="payment-method-btn"
                    onClick={() => {
                      onPaymentMethodSelected(key);
                    }}
                  >
                    {key}
                  </Button>
                );
              })}
            </Flex>
          )}
        </div>
      </Card>
    </div>
  );
}
